import Loadable from "react-loadable";

const LazyView = Loadable({
  loader: () => import(/* webpackChunkName: 'propale-view' */ "./view"),
  loading: () => 'loading...'
});

export default LazyView;
